import { isDate } from 'date-fns'
import { concat, map } from 'lodash'
import handleResponse from './request/handleResponse'

const buildUrl = (lang: string, page: number, modifyDate?: Date): string => {
  const d: number = isDate(modifyDate)
    ? Math.floor(modifyDate.getTime() / 1000)
    : 0

  return d > 0
    ? `/api/v2/notification/index/lang/${lang}/page/${page}/modify_date/${d}`
    : `/api/v2/notification/index/lang/${lang}/page/${page}/modify_date/0`
}

export function fetchNotificationPage(fetch: GlobalFetch) {
  return async function(
    lang: string,
    pageNumber = 0,
    ids: string[],
    modifyDate?: Date,
  ) {
    const body = {
      id: ids,
      lang,
      // eslint-disable-next-line @typescript-eslint/camelcase
      modify_date: isDate(modifyDate)
        ? Math.floor(modifyDate.getTime() / 1000)
        : 0,
      page: pageNumber,
    }
    const response = await fetch.fetch(
      buildUrl(lang === 'pl_PL' ? 'pl' : lang, pageNumber, modifyDate),
      {
        body: JSON.stringify(body),
        method: 'POST',
      },
    )

    return await handleResponse(response)
  }
}

export default function(fetch: GlobalFetch) {
  const fetchNotifications = fetchNotificationPage(fetch)

  return async function(
    lang: string,
    page: number,
    ids: string[],
    modifyDate?: Date,
  ) {
    const requests = Array.from(new Array(page + 1))
      .map((_, i) => i)
      .map(index =>
        fetchNotifications(
          lang === 'pl_PL' ? 'pl' : lang,
          index,
          ids,
          modifyDate,
        ),
      )

    const responses = await Promise.all(requests)

    return { ...responses[0], items: concat([], ...map(responses, 'items')) }
  }
}
